import { css, styled } from '@mui/material'

import AppLink from '~/shared/navigation/app-link'

export const StyledTitleRouterLink = styled(AppLink)(
  ({ theme }) => css`
    color: inherit;
    font-weight: 700;
    font-size: 24px;
    text-decoration: none;
    transition: color 0.2s ease;
    &:hover {
      color: ${theme.palette.primary.main};
    }
  `
)

export const StyledTitleLink = styled('a')(
  ({ theme }) => css`
    color: inherit;
    cursor: pointer;
    font-weight: 700;
    font-size: 24px;
    text-decoration: none;
    transition: color 0.2s ease;
    &:hover {
      color: ${theme.palette.primary.main};
    }
  `
)

export const StyledRouterLink = styled(AppLink)`
  color: #409beb; // TODO: 添加到主题中
  transition: color 0.2s ease;
  margin: 0 5px;
  text-decoration: none;
  text-align: center;
  &:hover {
    color: #003869; /* grey-lighter */
  }
`

export const StyledLink = styled('a')`
  color: #409beb; // TODO: 添加到主题中
  cursor: pointer;
  transition: color 0.2s ease;
  margin: 0 5px;
  text-decoration: none;
  text-align: center;
  &:hover {
    color: #003869; /* grey-lighter */
  }
`
